import * as React from 'react';
import { Field, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { paths } from 'config/path_helpers';
import { FieldInput, Form } from '@magoosh/lib/forms/template';
import { required } from '@magoosh/lib/forms/validations';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { RootStore } from '@magoosh/store';
import { SignupFormData } from '@magoosh/act/organisms/signup/types';

interface UserParams {
  email: string;
  password: string;
  acceptTerms: boolean;
  authenticityToken: string;
}

interface FormValues extends SignupFormData {
  gaveConsent: boolean;
}

interface UserFormProps {
  buttonText: string;
}

const UserForm = (props: InjectedFormProps<UserParams> & FormValues & UserFormProps) => {
  const { handleSubmit, error, gaveConsent, isEuUser, authenticityToken, buttonText } = props;
  return (
    <div className="u-margin-B-s">
      <Form onSubmit={handleSubmit} error={error} errorClass="danger">
        <FieldInput name="authenticityToken" type="hidden" value={authenticityToken} />
        <div className="row">
          <div className="col-md-6">
            <FieldInput label="Student Email" name="user[email]" type="text" validate={required} />
            <FieldInput label="Password" name="user[password]" type="password" validate={required} />
          </div>
        </div>

        {renderEuDisclaimer(isEuUser, buttonText)}
        <Button bsClass="btn btn-primary" type="submit" disabled={isEuUser && !gaveConsent}>
          {buttonText}
        </Button>
        {renderNonEuDisclaimer(isEuUser, buttonText)}
      </Form>
    </div>
  );
};

function renderEuDisclaimer(isEuUser: boolean, buttonText: string) {
  if (isEuUser) {
    return (
      <label>
        <Field name="acceptTerms" component="input" type="checkbox" />
        <span className="text-gray-light font-weight-normal u-margin-L-xs">
          I consent to Magoosh using my personal data to create my account and record my progress, and to
          receiving study tips, promotions, and other useful opportunities. We promise to treat your data with
          the utmost care and you can unsubscribe from messaging at any time. By clicking "{buttonText}", you
          agree to our{' '}
          <a href={paths.terms()} target="_blank">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={paths.privacy()} target="_blank">
            Privacy Policy
          </a>
          .
        </span>
      </label>
    );
  }
  return null;
}

function renderNonEuDisclaimer(isEuUser: boolean, buttonText: string) {
  if (!isEuUser) {
    return (
      <div>
        <small>
          By clicking "{buttonText}", you agree to our{' '}
          <a href={paths.terms()} target="_blank">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={paths.privacy()} target="_blank">
            Privacy Policy
          </a>
          .
        </small>
      </div>
    );
  }
  return null;
}

const SelectingUserForm = reduxForm({ form: 'userSignup' })(UserForm);

const selector = formValueSelector('userSignup');

export default connect((state: RootStore, ownProps: UserFormProps) => {
  const gaveConsent = selector(state, 'acceptTerms');
  return {
    gaveConsent,
    ...state.signup,
    ...ownProps
  };
})(SelectingUserForm);
